import React, { useContext } from 'react';
import './CustomerInfo.css'; // Import the updated CSS file
import { useOrderContext } from '../../../Context/OrderContext';
import { ShopContext } from '../../../Context/ShopContext';

const CustomerInfo = ({ onContinue, onBack }) => {
    const { formData, setFormData } = useOrderContext();
    const { cartItems } = useContext(ShopContext);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value, // Update specific field in formData
        }));
    };

    const handleContinue = async () => {

        // Check if cart is empty before proceeding
        if (Object.keys(cartItems).length === 0) {
            alert('Your cart is empty. Please add items to your cart before proceeding.');
            return;
        }

        const missingFields = [];
        if (!formData.name) missingFields.push('First Name');
        if (!formData.lastName) missingFields.push('Last Name');
        if (!formData.email) missingFields.push('Email');
        if (!formData.address) missingFields.push('Address');
        if (!formData.country) missingFields.push('Country');
        if (!formData.city) missingFields.push('City');
        if (!formData.postalCode) missingFields.push('Postal Code');
        if (!formData.phoneNumber) missingFields.push('Phone Number');
    
        if (missingFields.length > 0) {
            alert(`Please fill in the following fields: ${missingFields.join(', ')}`);
            return;
        }
    
        // Geocode the address to get coordinates
        const geocodeAddress = async (address) => {
            try {
                const response = await fetch(
                    `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
                );
                const data = await response.json();
                if (data.length > 0) {
                    const newPosition = { lat: data[0].lat, lng: data[0].lon };
                    setFormData(prevData => ({
                        ...prevData,
                        shippingAddress: newPosition, // Update coordinates in formData
                    }));
                    return true; // Address found and valid
                } else {
                    return false; // Address not found
                }
            } catch (error) {
                console.error('Error fetching geocode:', error);
            }
        };
    
        if (formData.address) {
            const isAddressValid = await geocodeAddress(formData.address); // Update coordinates based on the address

            if (!isAddressValid) {
                alert("Please enter a valid address");
                return;  // Prevent proceeding if the address is invalid
            }
        }
    
        onContinue(); // Move to the next step
    };

    return (
        <div className="form-section">
            <h2>Customer Information</h2>
            {/* Wrap First Name and Last Name in a row */}
            <div className="row">
                <div className="form-field">
                    <label htmlFor="name">First Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="custom-input"
                        value={formData.name || ''}
                        onChange={handleChange} 
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="lastName">Last Name</label>
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        className="custom-input"
                        value={formData.lastName}
                        onChange={handleChange} 
                    />
                </div>
            </div>

            <div className="form-field">
                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="custom-input"
                    value={formData.email}
                    onChange={handleChange} 
                />
            </div>

            <div className="form-field">
                <label htmlFor="address">Address</label>
                <input
                    type="text"
                    id="address"
                    name="address"
                    className="custom-input"
                    value={formData.address}
                    onChange={handleChange} 
                />
            </div>

            <div className="row">
                <div className="form-field">
                    <label htmlFor="country">Country</label>
                    <input
                        type="text"
                        id="country"
                        name="country"
                        className="custom-input"
                        value={formData.country}
                        onChange={handleChange} 
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="city">City</label>
                    <input
                        type="text"
                        id="city"
                        name="city"
                        className="custom-input"
                        value={formData.city}
                        onChange={handleChange} 
                    />
                </div>
            </div>

            <div className="row">
                <div className="form-field">
                    <label htmlFor="postalCode">Postal Code</label>
                    <input
                        type="text"
                        id="postalCode"
                        name="postalCode"
                        className="custom-input"
                        value={formData.postalCode}
                        onChange={handleChange} 
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <input
                        type="text"
                        id="phoneNumber"
                        name="phoneNumber"
                        className="custom-input"
                        value={formData.phoneNumber}
                        onChange={handleChange} 
                    />
                </div>
            </div>

            {/* Buttons container with flexbox */}
            <div className="button-container">
                <button type="button" onClick={onBack} className="back-button">Back</button>
                <button type="button" onClick={handleContinue} className="continue-button">Continue to Shipping</button>
            </div>
        </div>
    );
};

export default CustomerInfo;
